import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const uploadFilesRequest = payload =>
  actionRequestFactory(types.UPLOAD_FILES_REQUEST, payload);
export const uploadFilesSuccess = files =>
  actionResponseFactory(types.UPLOAD_FILES_SUCCESS, { files });
export const uploadFilesFailure = error =>
  actionResponseFactory(types.UPLOAD_FILES_FAILURE, { error });
